import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3349";
};

// Merchant Bank List
export const loadMerchantBankList = () => {
  const url = `${baseURL()}/suggestBusiness/bank/load
  `;

  return axios.get(url);
};
